import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Nav from '../../components/Nav'

// import ArtistTapestrySuccess from '../../components/ArtistTapestrySuccess'
// import ArtistGrid from '../../components/ArtistGrid'
// import ArtistModal from '../../components/ArtistModal'
// import compressed from '../../video/compressed.mp4'
import { Link } from 'react-router-dom'
// import PayButton from '../../components/PayButton'
// import { Elements } from '@stripe/react-stripe-js'
// import { loadStripe } from '@stripe/stripe-js'
// import CheckoutForm from '../../components/CheckoutForm'
// const stripePromise = loadStripe('pk_live_51Hm3AYEle5f5egjw5R8esKApXYNsGHWZFPadw0zN2eqjR96t4FZ6OJ77VUumIGOTWnBq0GU7cL4GwmT7kuv2QJ9K003tHe6tGt')

class Success extends Component {
  render () {
    return (
      <div>
        <div className='container mx-auto pt-8 pb-8'>
          <Nav />
        </div>
        <div className='bg-upton-100 pt-8 pb-8'>
          <div className='flex-1 flex flex-col items-center justify-center'>
            <h2 className='text-white text-xl lg:text-6xl font-thin'>Uh oh!</h2>
          </div>

        </div>

        <div className='w-100 min-h-screen bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12'>
          <div className='container text-white mx-auto p-6'>
            <p className='text-white text-left text-xl lg:text-3xl font-thin mt-6'>
              It looks like you cancelled your transaction.</p>
            <p className='text-white text-left text-xl lg:text-3xl font-thin mt-6'>If you still wish to buy tickets, go back to the <Link className='underline' to='/'>home page</Link>.</p>

          </div>
        </div>
      </div >

    )
  }
};

const mapStateToProps = ({ data }) => ({
  data
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Success))
